import PropTypes from "prop-types"
import { Backdrop, CircularProgress } from "@mui/material"
import { styled } from "@mui/material/styles"
import { colors } from "../../constants/colors"

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: colors.RED,
    backgroundColor: "rgba(240, 243, 245, 0.1)",
}))

export default function Spinner({ open }) {
    return (
        <div>
            <StyledBackdrop open={open} data-test="spinner">
                <CircularProgress />
            </StyledBackdrop>
        </div>
    )
}

Spinner.propTypes = {
    open: PropTypes.bool,
}
Spinner.defaultProps = { open: false }
